import axios, { AxiosRequestConfig } from 'axios';

const agent = axios.create({
  baseURL: process.env.AUTH_API_URI,
});

export const requestEmailLoginLink = (email: string, headers?: AxiosRequestConfig['headers']) => {
  return agent.post(
    '/v2/users/email_login',
    {
      email,
      audience: 'merchant-admin',
      signup: false,
    },
    {
      headers,
    },
  );
};
